import React from 'react';
import './style.scss';

import { transfromMsToHHMM } from '../../utils/common';

interface ITaskCard {
    taskId: number,
    uid: string,
    applicant: string,
    publicCountdown: number,
    extraClass?: string,
    showExplainBtn?: boolean,
    onClick?: (info: { uid: string, taskId: number}) => any
}

const TaskCard: React.FC<ITaskCard> = ({extraClass, taskId, uid, applicant, publicCountdown, showExplainBtn = true, onClick }) => {
    const handleOnClick = () => {
        onClick && onClick({
            uid,
            taskId
        })
    }
    return (
        <div className={`task-card-item ${extraClass ? extraClass : ''}`} >
            <p className="task-card-uid">{uid || ''}</p>
            <p className="task-card-applicant">申请人：<span>{applicant || ''}</span></p>
            <p className="task-card-countdown">剩余公示时长：<span>{transfromMsToHHMM(publicCountdown)}</span> </p>
            { showExplainBtn? <span className="task-card-explain-btn" onClick={() => handleOnClick()} >申诉</span> : '' }
        </div>
    )
}

export default TaskCard;
